import { DockContext } from '../context';
import { DOCK_NAVIGATOR_LINKS, DOCK_USER_LOCALE } from './index';

export const registerDockTopics = (context: DockContext) => {
  // Theme variant is registered at theme-manager/theme-variant.ts prepareThemeVariant call

  // Storage for navigator links
  context.register(DOCK_NAVIGATOR_LINKS, { retain: true, initialValue: [] });

  // Default user locale
  context.register(DOCK_USER_LOCALE, { retain: true, initialValue: 'en-gb' });
};
